var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 27.5C7.33671 24.0935 11.6971 22 16.5 22C21.3029 22 25.6633 24.0935 28.875 27.5M22.6875 10.3125C22.6875 13.7298 19.9173 16.5 16.5 16.5C13.0827 16.5 10.3125 13.7298 10.3125 10.3125C10.3125 6.89524 13.0827 4.125 16.5 4.125C19.9173 4.125 22.6875 6.89524 22.6875 10.3125Z",
    stroke: "#F9B26F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser03);
export default __webpack_public_path__ + "static/media/user-03.403c8be544f7a5e50ded56b59eb39d7e.svg";
export { ForwardRef as ReactComponent };